import router from './router'
import store from './store'
import {get} from '@/utils/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
const whitemList = ['/login']


router.beforeEach((to, from, next) => {
/*  let s = router.options.routes
  s.forEach(function (element, sameElement, set) {
    if (element.path==='/xtgl') {
      console.log(element.path)
      element.children.forEach(function(item){
        if (item.path === 'reportQuery'){
          item.meta = { title: '货物编码查询报表', keepAlive: true }
        }
        console.log(item)
      })
    }
  })*/

  NProgress.start()
  next()
  // if (get('token')) {
  //   if (to.path === '/login') {
  //     next({ path: '/' })
  //     NProgress.done()
  //   } else {
  //       next()
  //   }
  // } else {
  //   if (whitemList.indexOf(to.path) !== -1) {
  //     next()
  //   } else {
  //     next('/login')
  //   }
  // }

})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
